export const paths = {
  login: '/login',
  unauthorized: '/unauthorized',
  notRegistered: '/not-registered',
  dashboard: '/',
  appraisals: '/appraisals',
  appraisalDetail: '/appraisals/:id',
  jobEnd: '/job-ends/:id',
  settings: '/settings',
  staffingActivities: {
    occerSearch: '/staffing-activities/occer-search',
    jobEndAdmin: '/staffing-activities/job-end-admin',
    talentCommittees: '/staffing-activities/talent-committees',
    talentCommitteeRun: '/staffing-activities/talent-committee-run',
    calibrationMatrix: '/staffing-activities/calibration-matrix',
    appraisalAdmin: '/staffing-activities/appraisal-admin',
  },
  admin: {
    impersonate: '/admin/impersonate',
    notificationTemplates: '/admin/notification-templates',
    notificationTemplateDetail: '/admin/notification-templates/:id',
    desktopNotifications: '/admin/desktop-notifications',
    desktopNotificationDetail: '/admin/desktop-notifications/:id',
    skillsMatrix: '/admin/skills-matrix',
    manualJobEnd: '/admin/manual-job-end',
  },
} as const;
